var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"games-view"}},[_c('nav-component'),_c('h1',[_vm._v("Select a Game to Play")]),_c('card-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }